<template>
    <div class="turntable" v-if="gameInfo">
        <div class="turntable-left">
            <el-image :src="$util.img('upload/uniapp/game/rule_head.png')" fit="contain" style="width: 100%;"></el-image>
            <div v-if="gameInfo">
                <span class="title">活动时间</span>
                <span>{{ formatTimestamp(gameInfo?.start_time) }} 至 {{ formatTimestamp(gameInfo?.end_time) }}</span>
                <span class="title">参与规则</span>
                <span v-if="gameInfo.join_type == 0">
                    每个用户活动期间共有{{ gameInfo.join_frequency }}次抽奖机会。
                </span>
                <span v-else>
                    每个用户活动期间每天都有{{ gameInfo.join_frequency }}次抽奖机会，每天0点更新。
                </span>
                <span v-if="gameInfo.points>0">
                    当前拥有{{ point }}积分，每次抽奖需消耗 {{ gameInfo.points }} 积分
                </span>
                <span v-if="gameInfo.level_id != 0">
                    该活动只有{{ gameInfo.level_name }}等级的客户可参与。
                </span>
                <template v-if="gameInfo.remark != ''">
                    <span class="title">活动说明</span>
                    <span>{{ gameInfo.remark }}</span>
                </template>
            </div>
        </div>
        <div class="turntable-center">
            <el-image :src="$util.img('upload/uniapp/game/turntable_head.png')" fit="contain" style="width: 100%;"></el-image>
            <!-- 中奖公告滚动 -->
            <div class="announcement-scroll" v-if="gameInfo.is_show_winner && gameInfo.draw_record">
                <div class="announcement-title">中奖名单</div>
                <div class="announcement-content" :class="{ 'animate': animate }">
                    <div class="announcement-item" v-for="(item, index) in gameInfo.draw_record" :key="index">
                        <!-- 名字中间加*** -->
                        {{ item.member_nick_name.slice(0, 1) + '***' + item.member_nick_name.slice(-1) }} {{ formatTimeAgo(item.create_time) }}获得 {{ item.award_name }}
                    </div>
                </div>
            </div>
            <div class="turntable-center-content">
                <!-- $util.img('/upload/uniapp/game/turntable_bg.png') -->
                 <el-image :src="$util.img('/upload/uniapp/game/turntable_bg.png')" fit="contain"></el-image>
                 <div class="award-wrap">
                    <template v-for="(item, index) in gameInfo.award">
                        <template v-if="index === 4">
                            <template v-if="gameInfo.status == 1">
                                <div @click="lottery" :class="['star-box',{'disabled':gameInfo.surplus_num <= 0 || !token},{ on: index == currentIndex }]">
                                    <div class="text">立即抽奖</div>
                                    <div class="tips">剩余{{ gameInfo.surplus_num }}次</div>
                                </div>
                            </template>
                            <template v-else-if="gameInfo.status == 0">
                                <div class="star-box disabled">
                                    <div class="tips">活动尚未开始</div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="star-box disabled">
                                    <div class="tips">活动已结束</div>
                                </div>
                            </template>
                        </template>
                        <div class="box" :class="{ on: index == currentIndex }">
                            <div class="award-img">
                                <template v-if="item.award_id>-1">
                                    <el-image :preview-src-list="[$util.img(item.award_img)]" :src="$util.img(item.award_img)" fit="contain" style="width: 100%;height: 100%;"></el-image>
                                </template>
                                <template v-else>
                                    <el-image :src="$util.img(item.award_img)" fit="contain" style="width: 100%;height: 100%;"></el-image>
                                </template>
                            </div>
                            <div class="award-text">{{ item.award_name }}</div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="turntable-right">
            <span>中奖记录</span>
            <div class="record-list">
                <div v-if="recordList.length > 0">
                    <div class="record-item" v-for="(item, index) in recordList" :key="index">
                        <div class="image-wrap">
                            <img :src="$util.img(item.award_img)" alt="积分">
                        </div>
                        <div class="content">
                            <div class="name">{{ item.award_name }}</div>
                            <div class="cont" v-if="item.award_type == 1">奖励详情：{{ item.point }}个积分</div>
                            <div class="cont" v-if="item.award_type == 2">奖励详情：{{ item.balance }}元红包</div>
                            <div class="cont" v-if="item.award_type == 3">奖励详情：优惠券“{{ item.relate_name }}”</div>
                            <div class="time">中奖时间：{{ formatTimestamp(item.create_time) }}</div>
                        </div>
                        <div class="btn" v-if="item.award_type == 1" @click="$router.push('/member/my_point')">查看</div>
                        <div class="btn" v-if="item.award_type == 2" @click="$router.push('/member/account')">查看</div>
                        <div class="btn" v-if="item.award_type == 3" @click="$router.push('/member/my_coupon')">查看</div>
                    </div>
                </div>
                <div v-else class="empty-record">
                    暂无中奖记录
                </div>
            </div>
            <!-- 分页组件 -->
            <div class="paginationBox" v-if="total > 0">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="prev, pager, next"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <!-- 中奖结果弹窗 -->
        <div v-if="dialogVisible" class="result-popup-overlay" @click="closePopup">
            <div class="result-popup-content" @click.stop>
                <span class="close-btn" @click="closePopup">&times;</span>
                <div class="result-wrap">
                    <div v-if="result && result.is_winning" class="content-wrap yes">
                        <img :src="$util.img(gameInfo.award[resultIndex].award_img)" alt="奖品图片" class="look">
                        <div class="msg">恭喜您抽中{{ gameInfo.award[resultIndex].award_name }}</div>
                        <div class="btn" @click="closePopup">{{ result.award_type==4?'加入购物车':'继续抽奖' }}</div>
                    </div>
                    <div v-else-if="result && !result.is_winning" class="content-wrap">
                        <img :src="$util.img('upload/uniapp/game/result_look.png')" alt="未中奖" class="look">
                        <div class="msg">{{ gameInfo.no_winning_desc }}</div>
                        <div class="btn" @click="closePopup">继续抽奖</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getGameInfo,startLottery,getRecordPage } from "@/api/activity/turntable";
import { memberDetail } from "@/api/member/member";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            gameInfo: null,
            memberInfo: null,
            isClick: false,
            currentIndex: -1, // 当前选中
            maxRing: 6, // 最大圈数,
            currentRing: 1, // 当前圈数
            speed: 300, // 转数
            timer: null,
            result: null,
            resultIndex: 0,
            point: 0,
            award: [],
            animate: false,
			scrollTimer: null,
            // 中奖记录
            recordList: [],
            // 分页相关
            currentPage: 1,
            pageSize: 10,
            total: 0,
            // 弹窗控制
            dialogVisible: false,
        }
    },
    mounted() {
        this.getGameInfo();
        this.getMemberPointInfo();
        this.getRecordPage();
    },
    beforeDestroy() {
        if (this.scrollTimer) {
            clearInterval(this.scrollTimer);
            this.scrollTimer = null;
        }
    },
    computed: {
        ...mapGetters(["token"]),
    },
    methods: {
        /**
         * 分页查询中奖记录
         */
        getRecordPage() {
            getRecordPage({
                page: this.currentPage,
                page_size: this.pageSize,
                id: this.$route.query.game_id
            }).then(res => {
                if (res.code == 0 && res.data) {
                    this.recordList = res.data.list || [];
                    this.total = res.data.count || 0;
                }
            })
        },
        // 分页切换
        handleCurrentChange(page) {
            this.currentPage = page;
            this.getRecordPage();
        },
        // 每页显示条数变化
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
            this.getRecordPage();
        },
        getMemberPointInfo() {
            memberDetail().then(res => {
                if (res.code == 0 && res.data) {
                    this.point = parseInt(res.data.point);
                    this.memberInfo = res.data;
                }
            })
        },
        /**
         * 获取游戏信息
         */
        async getGameInfo() {
            const res = await getGameInfo({
                id: this.$route.query.game_id
            })
            if (res.code == 0 && res.data) {
                // 得到如下
                // {"code":0,"message":"操作成功","data":{"game_id":3,"game_name":"测试抽奖","points":5,"start_time":1769670539,"end_time":1772208000,"status":1,"remark":"","no_winning_desc":"很遗憾，未中奖","no_winning_img":"upload\/uniapp\/game\/no_winning.png","is_show_winner":0,"level_id":"0","level_name":"","join_type":0,"join_frequency":1,"award":[{"award_id":-1,"award_name":"谢谢参与","award_img":"upload\/uniapp\/game\/no_winning.png"},{"award_id":-1,"award_name":"谢谢参与","award_img":"upload\/uniapp\/game\/no_winning.png"},{"award_id":-1,"award_name":"谢谢参与","award_img":"upload\/uniapp\/game\/no_winning.png"},{"award_id":-1,"award_name":"谢谢参与","award_img":"upload\/uniapp\/game\/no_winning.png"},{"award_id":-1,"award_name":"谢谢参与","award_img":"upload\/uniapp\/game\/no_winning.png"},{"award_id":-1,"award_name":"谢谢参与","award_img":"upload\/uniapp\/game\/no_winning.png"},{"award_id":11,"award_name":"赠品","award_img":"https:\/\/image.shenglitaiyy.com\/upload\/1\/common\/images\/20260123\/20260123023330176915001008169.png"},{"award_id":-1,"award_name":"谢谢参与","award_img":"upload\/uniapp\/game\/no_winning.png"}],"surplus_num":1},"timestamp":1772011074}
                this.gameInfo = res.data;
                if(this.gameInfo.award){
                    this.award = res.data.award.map(e => e.award_id);
                }
                if (this.gameInfo.is_show_winner && this.gameInfo.draw_record.length > 6) {
                    this.scrollTimer = setInterval(this.scrollRecord, 2000);
                }
            }else{
                this.$message({ message: '活动不存在', type: 'error' });
                // 返回首页
                this.$router.push({ path: '/index' });
            }
        },
        scrollRecord() {
            this.animate = true;
            setTimeout(() => {
                this.gameInfo.draw_record.push(this.gameInfo.draw_record[0]); // 将数组的第一个元素添加到数组的
                this.gameInfo.draw_record.shift();
                this.animate = false;
            }, 300); // 与动画持续时间匹配
        },
        lottery() {
            if (!this.token) {
                this.$message({ message: '请先登录', type: 'warning' });
                return;
            }
            if (this.gameInfo.status != 1) return;
            if (this.gameInfo.surplus_num <= 0) {
                this.$message({ message: '您的抽奖次数已用完', type: 'warning' });
                return;
            }
            let levelId = ',' + this.gameInfo.level_id + ',';
            if (this.gameInfo.level_id != '0' && levelId.indexOf(',' + this.memberInfo.member_level + ',') == -1) {
                this.$message({ message: '该活动只有'+ this.gameInfo.level_name +'等级的客户可参与该活动', type: 'warning' });
                return;
            }
            if (this.gameInfo.points > 0 && this.point < this.gameInfo.points) {
                this.$message({ message: '您的积分不足', type: 'warning' });
                return;
            }
            if (this.isClick) return;
            this.isClick = true;

            startLottery({ id: this.$route.query.game_id }).then(res => {
                if (res.code >= 0) {
                    // 初始化转盘参数
                    this.currentIndex = 0;
                    this.currentRing = 1;
                    this.speed = 300;
                    this.timer = setInterval(()=>{
                        this.startRoll('interval');
                    }, this.speed);
                    this.result = res.data;
                    if (res.data.is_winning) {
                        this.resultIndex = this.$util.inArray(res.data.award_id, this.award);
                    } else {
                        let temArr = [];
                        this.award.forEach((item,index) => {
                            if(item == -1){
                                temArr.push({
                                    index: index,
                                    value: item
                                })
                            }
                        })
                        if(temArr.length>1){
                            this.resultIndex = temArr[Math.floor(Math.random() * temArr.length)].index;
                        }else{
                            this.resultIndex = this.$util.inArray(-1, this.award);
                        }
                    }
                    // 扣除次数 积分
                    this.point -= this.gameInfo.points;
                    this.gameInfo.surplus_num -= 1;
                } else {
                    this.$message({ message: res.message, type: 'error' });
                    this.isClick = false;
                }
            })
        },
        startRoll(type) {
            let self = this;
            function clearTimer(){
                if(type=='interval'){
                    clearInterval(self.timer);
                    self.timer = null;
                }
                if(type=='timeout'){
                    clearTimeout(self.timer);
                    self.timer = null;
                }
                
            }
            if (this.speed > 50) {
                this.speed -= 50;
            }
            if (this.currentRing >= this.maxRing - 1 && this.speed < 700) {
                this.speed += 100;
            }
            console.log("效验结果：",this.currentRing,this.currentIndex,this.resultIndex,this.maxRing,this.speed,"是否结束：",(this.currentRing == this.maxRing && this.currentIndex == this.resultIndex))
            if (this.currentRing == this.maxRing && this.currentIndex == this.resultIndex) {
                clearTimer();
                this.showResult();
                console.log('转动结束');
                return;
            }
            if (this.currentIndex == 7) {
                this.currentRing += 1;
                this.currentIndex = 0;
            } else {
                this.currentIndex += 1;
            }
            clearTimer();
            this.timer = setTimeout(()=>{
                this.startRoll('timeout');
            }, this.speed); //开始转动
            console.log('转动中', type, this.currentRing, this.currentIndex);
        },
        // 展示中奖结果
        showResult() {
            this.dialogVisible = true;
        },
        // 关闭弹窗
        closePopup() {
            this.dialogVisible = false;
            this.isClick = false;
        },
        // 时间戳转换为日期
        formatTimestamp(timestamp) {
            const date = new Date(timestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        // 时间戳转换为相对时间
        formatTimeAgo(timestamp) {
            const now = Date.now();
            const then = new Date(timestamp * 1000);
            const diff = now - then.getTime();
            const seconds = Math.floor(diff / 1000);
            const minutes = Math.floor(seconds / 60);
            const hours = Math.floor(minutes / 60);
            const days = Math.floor(hours / 24);
            if (seconds < 60) {
                return '刚刚';
            } else if (minutes < 60) {
                return `${minutes} 分钟前`;
            } else if (hours < 24) {
                return `${hours} 小时前`;
            } else if (days < 7) {
                return `${days} 天前`;
            } else {
                return this.formatTimestamp(timestamp);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.turntable{
    width: 100%;
    height: 600px;
    margin: 12px 0;
    display: flex;
    gap: 12px;
    &-left{
        width: calc((100% - 402px) /2);
        background-color: #fff;
        border-radius: 12px;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px;
        box-sizing: border-box;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        >div{
            display: flex;
            flex-direction: column;
            gap: 15px;
            .title{
                font-size: 18px;
                font-weight: bold;
                color: #32BC6F;
                margin-top: 10px;
                position: relative;
                &::before {
                    content: '';
                    position: absolute;
                    left: -10px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 4px;
                    height: 18px;
                    background: #32BC6F;
                    border-radius: 2px;
                }
            }
            span:not(.title) {
                font-size: 14px;
                color: #666;
                line-height: 1.6;
                padding-left: 14px;
            }
        }
    }
    &-center{
        width: 390px;
        height: 100%;
        background-image: linear-gradient(#f3623f, #f74222);
        display: flex;
        flex-direction: column;
        position: relative;
        border-radius: 12px;
        overflow: hidden;
        .announcement-scroll {
            background: rgba(255, 255, 255, 0.9);
            border-radius: 20px;
            padding: 8px 15px;
            display: flex;
            align-items: center;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            position: absolute;
            top: 12px;
            left: 12px;
            box-sizing: border-box;
            width: calc(100% - 24px);
            overflow: hidden;
            .announcement-title {
                font-size: 14px;
                font-weight: 600;
                color: #ff3301;
                margin-right: 10px;
                white-space: nowrap;
            }
            .announcement-content {
                flex: 1;
                overflow: hidden;
                position: relative;
                height: 20px;
                .announcement-item {
                    font-size: 13px;
                    color: #666;
                    line-height: 20px;
                    white-space: nowrap;
                    transition: opacity 0.3s ease, transform 0.3s ease;
                }
                &.animate {
                    transition: transform 0.3s ease;
                    transform: translateY(-30px);
                }
            }
        }
        &-content{
            position: absolute;
            width: 100%;
            box-sizing: border-box;
            bottom: 12px;
            display: flex;
            flex-direction: column;
            >.el-image{
                position: absolute;
                z-index: 1;
                width: 100%;
                bottom: 0;
            }
        }
        .award-wrap{
            position: relative;
            z-index: 2;
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            padding: 34px;
            box-sizing: border-box;
            .disabled {
                box-shadow: 0 0.25em 0 #999 !important;
                background: linear-gradient(#ccc, #aaa) !important;

                .text {
                    color: #888 !important;
                }

                .tips {
                    color: #777 !important;
                    background: #aaa !important;
                }
            }
            .star-box{
                display: flex;
                flex-direction: column;
                width: calc((100% - 24px) / 3);
                height: 84px;
                overflow: hidden;
                background: linear-gradient(#ffe1ac, #fec965);
                box-shadow: 0 0.25em 0 rgba(225, 157, 31, 1);
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                cursor: pointer;

                .text {
                    font-size: 17px;
                    font-weight: 600;
                    color: #ff3301;
                    text-align: center;
                }
                .tips {
                    font-size: 12px;
                    display: inline-block;
                    background: #f0a71d;
                    line-height: 1;
                    color: #ff3301;
                    padding: 6px 12px;
                    border-radius: 12px;
                }
            }
            .box {
                display: flex;
                flex-direction: column;
                width: calc((100% - 24px) / 3);
                height: 84px;
                overflow: hidden;
                background: #fff;
                border-radius: 4px;
                box-shadow: inset 0 0 24px 0 #ffd6ab, 0 0.25em 0 rgba(248, 166, 131, 0.96);
                align-items: center;
                justify-content: center;

                &.on {
                    background: linear-gradient(#ffe1ac, #fec965);
                    box-shadow: 0 0.25em 0 rgba(225, 157, 31, 1);

                    .award-text {
                        color: #ff3301;
                    }
                }

                .award-img {
                    width:35px;
                    height: 35px;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    overflow: hidden;

                    image {
                        width: 35px;
                        height: 35px;
                    }
                }

                .award-text {
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-top: 5px;
                    font-size: 16px;
                    padding: 0 20px;
                    color: #666;
                }
            }
        }
    }
    &-right{
        width: calc((100% - 402px) /2);
        height: 100%;
        background-color: #fff;
        border-radius: 12px;
        padding: 20px;
        box-sizing: border-box;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        >span{
            font-size: 18px;
            font-weight: bold;
            color: #32BC6F;
            display: block;
            margin-bottom: 12px;
            position: relative;
            &::before {
                content: '';
                position: absolute;
                left: -10px;
                top: 50%;
                transform: translateY(-50%);
                width: 4px;
                height: 18px;
                background: #32BC6F;
                border-radius: 2px;
            }
        }
        .record-list {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            .record-item {
                display: flex;
                align-items: center;
                padding: 15px;
                margin-bottom: 12px;
                background: #f9f9f9;
                border-radius: 8px;
                transition: all 0.1s ease;
                cursor: default;
                &:hover {
                    background: #f0f0f0;
                }
                .image-wrap {
                    width: 50px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 15px;
                    img {
                        width: 30px;
                        height: auto;
                    }
                }
                .content {
                    flex: 1;
                    .name {
                        font-size: 16px;
                        font-weight: 600;
                        color: #333;
                        margin-bottom: 5px;
                    }
                    .cont {
                        font-size: 14px;
                        color: #666;
                        margin-bottom: 5px;
                    }
                    .time {
                        font-size: 12px;
                        color: #999;
                    }
                }
                .btn {
                    padding: 3px 12px;
                    box-sizing: border-box;
                    background: #32BC6F;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 600;
                    border-radius: 6px;
                    cursor: pointer;
                    transition: all 0.1s ease;
                    box-shadow: 0 4px 10px rgba(255, 107, 53, 0.2);
                }
            }
            .empty-record {
                text-align: center;
                padding: 40px 0;
                color: #999;
                font-size: 14px;
            }
            
        }
        .paginationBox {
            margin-top: 12px;
            display: flex;
            justify-content: flex-end;
            .el-pagination {
                .el-pagination__sizes {
                    margin-right: 10px;
                }
                .el-pagination__total {
                    margin-right: 10px;
                    color: #666;
                }
                .el-pagination__item {
                    &:hover {
                        color: #32BC6F;
                    }
                    &.is-active {
                        background-color: #32BC6F;
                        border-color: #32BC6F;
                    }
                }
                .el-pagination__prev:hover,
                .el-pagination__next:hover {
                    color: #32BC6F;
                }
            }
        }
    }
}

/* 中奖结果弹窗样式 */
.result-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;
}

.result-popup-content {
    width: 400px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    position: relative;
    animation: scaleIn 0.3s ease;
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f5f5f5;
    color: #999;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.2s ease;
    &:hover {
        background: #32BC6F;
        color: #fff;
        // transform: scale(1.1);
    }
}

.result-wrap {
    position: relative;
    padding: 50px 30px;
    text-align: center;
    .content-wrap {
        position: relative;
        z-index: 2;
        .look {
            width: 140px;
            height: auto;
            margin: 0 auto 30px;
            animation: bounce 1s ease-in-out;
        }
        .msg {
            font-size: 20px;
            color: #333;
            margin-bottom: 40px;
            line-height: 1.4;
            padding: 0 20px;
        }
        .btn {
            display: inline-block;
            padding: 15px 50px;
            background: #32BC6F;
            color: #fff;
            font-size: 18px;
            font-weight: 600;
            border-radius: 30px;
            cursor: pointer;
            box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
            transition: all 0.3s ease;
            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);
            }
        }
        &.yes {
            .msg {
                color: #ff3301;
                font-weight: 600;
                animation: pulse 1s ease-in-out;
            }
            .look {
                animation: bounce 1s ease-in-out, pulse 2s infinite;
            }
        }
    }
}

/* 动画效果 */
@keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-20px);
    }
    60% {
        transform: translateY(-10px);
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes scaleIn {
    from {
        transform: scale(0.8);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}
</style>